'use client';
import React, { useId, useState } from 'react';
import { ChevronIcon } from '@/components/ui/Icons';
import classNames from 'classnames';

export type TypeUseAccordionProps = {
  defaultIsOpen?: boolean;
};

export const useAccordion = (props?: TypeUseAccordionProps) => {
  const [isOpen, setIsOpen] = useState(props?.defaultIsOpen || false);
  const accordionId = useId();

  const Icon = () => {
    return (
      <ChevronIcon
        classes="md:w-[24px] md:h-[24px] w-[20px] h-[20px]"
        direction={isOpen ? 'up' : 'down'}
      />
    );
  };

  const Accordion = ({
    collapsedContent,
    expandedContent,
  }: {
    collapsedContent: React.ReactNode;
    expandedContent: React.ReactNode;
  }) => {
    return (
      <div className="border-b border-y-charcoal-opacity-20">
        <button
          id={accordionId}
          aria-expanded={isOpen}
          aria-controls={`sect-${accordionId}`}
          onClick={() => setIsOpen(!isOpen)}
          className={classNames(
            'accordion collapse mx-auto w-full',
            isOpen ? 'collapse-open' : 'collapse-close',
          )}
        >
          {collapsedContent}
        </button>
        {isOpen && expandedContent}
      </div>
    );
  };

  return {
    Icon,
    Accordion,
  };
};
